import { render, staticRenderFns } from "./zesa-portal.vue?vue&type=template&id=6f23cf9d&scoped=true"
import script from "./zesa-portal.vue?vue&type=script&lang=js"
export * from "./zesa-portal.vue?vue&type=script&lang=js"
import style0 from "./zesa-portal.vue?vue&type=style&index=0&id=6f23cf9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23cf9d",
  null
  
)

export default component.exports